import React from "react";
import { Link } from "react-router-dom";
import { LOGO_WHITE } from "../lib/api";
import FooterNewsletter from "./footer/FooterNewsletter";
import FooterSocial from "./footer/FooterSocial";
import FooterLinks from "./footer/FooterLinks";
import FooterLegal from "./footer/FooterLegal";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative border-t border-white/5 bg-[#050814] pt-20 pb-10 mt-20"
        >
            <div className="xpo-container">
                <FooterNewsletter />

                <div className="grid grid-cols-2 md:grid-cols-5 gap-10 mb-12">
                    <div className="col-span-2">
                        <Link to="/" className="flex items-center mb-5">
                            <img
                                src={LOGO_WHITE}
                                alt="XPO Markets"
                                className="h-14 w-auto object-contain"
                            />
                        </Link>
                        <p className="text-slate-400 text-sm leading-relaxed max-w-sm">
                            Trade Forex and Crypto CFDs on the MetaTrader 5
                            engine. Regulated, transparent, and built for
                            serious traders.
                        </p>
                        <FooterSocial />
                    </div>
                    <FooterLinks />
                </div>

                <FooterLegal />
            </div>
        </footer>
    );
}
